(function () {
  if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;

  var bound = new WeakSet();

  function bind(btn) {
    if (bound.has(btn)) return;
    bound.add(btn);

    var rect = null;

    function onEnter() {
      rect = btn.getBoundingClientRect();
      btn.classList.add('sovyer-magnetic');
    }

    function onMove(e) {
      if (!rect) rect = btn.getBoundingClientRect();
      var dx = e.clientX - (rect.left + rect.width / 2);
      var dy = e.clientY - (rect.top + rect.height / 2);
      btn.style.setProperty('--mag-x', (dx * 0.25).toFixed(1) + 'px');
      btn.style.setProperty('--mag-y', (dy * 0.25).toFixed(1) + 'px');
    }

    function onLeave() {
      btn.classList.remove('sovyer-magnetic');
      btn.style.setProperty('--mag-x', '0px');
      btn.style.setProperty('--mag-y', '0px');
      rect = null;
    }

    btn.addEventListener('mouseenter', onEnter);
    btn.addEventListener('mousemove', onMove);
    btn.addEventListener('mouseleave', onLeave);
  }

  function init() {
    document.querySelectorAll('a.button, button.button').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
